import React from "react"
import { useFormContext } from "react-hook-form"
import { isInvalidClass } from "../../config/helpers";

interface IOption {
    id: number | string; 
    name: string;
    value: number | string; 
  }

interface IProps {
    label?: string,
    formName: string,
    ismandatory?: boolean,
    //defaultValue?: number;
    options:IOption[],
    disabled?: boolean,
    //onchange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
const RadioInput: React.FC<IProps> = ({
    formName,
    label = formName,
    ismandatory,
    options,
    disabled,
    //defaultValue,
    //onchange
}) => {
    const {register, getFieldState,setValue,watch } = useFormContext();//, formState: { errors }

    const watchedformName= watch(formName);
    

    
    return (
        <>
        <div className="form-section inline-inputs">
            {label}
            {ismandatory && <em className="text-danger">*</em>}
            {options.map((option:IOption, key:number) => (
                <div
                    className="form-check form-check-inline"
                    key={key + "cont_" + option.name.trim() + option.value}
                >
                    <input
                        className={`form-check-input ${isInvalidClass(getFieldState(formName).error)}`}
                        id={`${formName}_${option.id}`}
                        {...register(formName)}
                        type="radio"
                        value={option.value}
                        
                        checked={watchedformName?.toString() === option.value?.toString() ? true : false} //{defaultValue === option.value}
         
                        onChange={(event) => {
                            setValue(formName,Number(event.target.value));
                          }}
                        name={formName}
                        disabled={disabled}
                    />
                    <label
                        className="form-check-label"
                        htmlFor={key + "_" + option.name}
                    >
                        &nbsp;{option.name}
                    </label>
                </div>
            ))}
        </div>
        </>
    )
}

export default RadioInput